export default {
    data () {
        return {
            downloadQueue: {}
        }
    },
    methods: {
        // 推到下载队列
        __pushToDownList (folderId) {
            return new Promise((resolve, reject) => {
                if (!folderId && folderId !== 0) {
                    this.$message.error('需要下载的文件夹 id 不存在!');
                    return
                }
                const notifyCls = 'downFilderIng' + folderId
                if (this.downloadQueue[notifyCls]) {
                    this.$message.error(folderId + '，该文件已在下载中。。。');
                    return false
                }
                this.downloadQueue[notifyCls] = {}
                this.downloadQueue[notifyCls]['notify'] = this.$notify({
                    title: '提示：' + folderId + '下载中',
                    message: `当前进度： 0/100`,
                    duration: 0,
                    customClass: notifyCls
                })
                resolve()
            })
        },
        // 更新下载进度
        __updateDownProgressData (folderId, progress) {
            const notifyCls = 'downFilderIng' + folderId
            const notifyDom = document.querySelector('.'+ notifyCls + ' .el-notification__content p')
            if (notifyDom) {
                const proNum = (progress.loaded / progress.total) * 100
                notifyDom.textContent = `下载进度 ${proNum.toFixed(2)}/100`
            }
        },
        __completeDownload (folderId, resp, downName) {
            const notifyCls = 'downFilderIng' + folderId

            const url = window.URL.createObjectURL(new Blob([resp], { type: 'application/octet-stream;charset=utf-8' }))
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', `${downName}.zip`)
        
            document.body.appendChild(link)
            link.click()
            this.downloadQueue[notifyCls]['notify'].close()
            this.$message({
                message: '下载完成',
                type: 'success'
            })

            this.$nextTick(() => {
                this.$delete(this.downloadQueue, notifyCls)
            })
        }
    }
}